import Vue from 'vue';

/**
 * Currently used for emitting global model change events
 * E.g. for the undo/redo system 
 */
export const GlobalEventEmitter = new Vue();



// WEBPACK FOOTER //
// ./ClientApp/infrastructure/global-event-emitter.ts